import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname, search, hash } = useLocation();

  useLayoutEffect(() => {
    // Reset body overflow that ChatbotModal may have set
    document.body.style.overflow = '';

    // Force scroll to top on every route change
    window.scrollTo(0, 0);

    // Also reset any hash-based scroll
    if (!hash) {
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    }
  }, [pathname, search, hash]);

  return null;
}
